/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Chci distribuovat svou značku na webu.`
};

const da_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg ønsker at distribuere mit mærke på siden.`
};

const de_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Ich möchte meine Marke auf der Website vertreiben.`
};

const en_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `I want to distribute my brand on the website.`
};

const es_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Quiero distribuir mi marca en el sitio.`
};

const fr_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Je souhaite distribuer ma marque sur le site.`
};

const hu_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Szeretnék márkámat terjeszteni az oldalon.`
};

const it_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Voglio distribuire il mio marchio sul sito.`
};

const nl_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Ik wil mijn merk op de site verkopen.`
};

const pl_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Chcę sprzedawać moją markę na stronie.`
};

const pt_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Quero vender minha marca no site.`
};

const sv_contact_subjects_brand_distribution = /** @type {(inputs: {}) => string} */ () => {
	return `Jag vill sälja mitt varumärke på sidan.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_brand_distribution = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_brand_distribution(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_brand_distribution", locale)
	if (locale === "cs") return cs_contact_subjects_brand_distribution(inputs)
	if (locale === "da") return da_contact_subjects_brand_distribution(inputs)
	if (locale === "de") return de_contact_subjects_brand_distribution(inputs)
	if (locale === "en") return en_contact_subjects_brand_distribution(inputs)
	if (locale === "es") return es_contact_subjects_brand_distribution(inputs)
	if (locale === "fr") return fr_contact_subjects_brand_distribution(inputs)
	if (locale === "hu") return hu_contact_subjects_brand_distribution(inputs)
	if (locale === "it") return it_contact_subjects_brand_distribution(inputs)
	if (locale === "nl") return nl_contact_subjects_brand_distribution(inputs)
	if (locale === "pl") return pl_contact_subjects_brand_distribution(inputs)
	if (locale === "pt") return pt_contact_subjects_brand_distribution(inputs)
	return sv_contact_subjects_brand_distribution(inputs)
};
export { contact_subjects_brand_distribution as "contact.subjects.brand_distribution" }